import { render } from "./JobStackDeploymentDetailsEdit.vue?vue&type=template&id=08fef48a&scoped=true"
import script from "./JobStackDeploymentDetailsEdit.vue?vue&type=script&lang=js"
export * from "./JobStackDeploymentDetailsEdit.vue?vue&type=script&lang=js"

import "./JobStackDeploymentDetailsEdit.vue?vue&type=style&index=0&id=08fef48a&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fef48a"]])

export default __exports__